(function(){
  var root=document.querySelector('[data-sgmu]'); if(!root) return;
  root.classList.add('is-js');
  var mans=[].slice.call(root.querySelectorAll('[data-man]')), hub=root.querySelector('[data-hub]');
  function stickyOffset(){
    var h=document.querySelector('header'); var v=0;
    if(h){var s=getComputedStyle(h).position; if(s==='sticky'||s==='fixed'){v=h.getBoundingClientRect().height}
      else{var p=h.closest('.shopify-section-group-header-group,.section-header'); if(p&&getComputedStyle(p).position==='sticky'){v=p.getBoundingClientRect().height}}}
    root.style.setProperty('--sgm-sticky',Math.round(v)+'px');
  }
  function route(){
    var parts=decodeURIComponent(location.hash.slice(1)).split('/'), slug=parts[0], ch=parts[1];
    var m=mans.filter(function(x){return x.getAttribute('data-man')===slug})[0];
    mans.forEach(function(x){x.classList.toggle('is-active',x===m)});
    if(hub) hub.classList.toggle('is-hidden',!!m);
    stickyOffset();
    if(m && ch){ var t=document.getElementById(slug+'-'+ch); if(t) setTimeout(function(){t.scrollIntoView({behavior:'smooth',block:'start'})},30); }
    else { var top=root.getBoundingClientRect().top+window.pageYOffset-stickyOffset(); window.scrollTo({top:Math.max(top,0),behavior:'auto'}); }
  }
  window.addEventListener('hashchange',route); window.addEventListener('resize',stickyOffset);
  root.addEventListener('click',function(e){
    if(e.target.closest('[data-sgm-print]')){ [].forEach.call(root.querySelectorAll('details'),function(d){d.open=true}); window.print(); }
  });
  route();
})();
